export var JumpBallSuccess = {
  name: "jumpball-succss",
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "edit.jumpBall.success",
  showOn: [{ state: "editState", value: "jumpball_success", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  showDetails: { events: ["edit"] },
  children: [
    {
      name: "jumpball_success_description",
      component: "PanelText",
      layout: "panel-text",
      mode: "visible",
      showOn: [true],
      options: {
        layout: "description-text",
        text: "edit.jumpBall.success.description",
      },
      actionGroups: [],
    },
    // Shot Type / Options confirm
    {
      name: "confirm-panel",
      component: "SubPanel",
      layout: "sub-panel",
      mode: "visible",
      text: null,
      showOn: [true],
      children: [
        {
          name: "ok-button",
          component: "TypeButton",
          layout: "match-button action",
          mode: "enable",
          text: "ok",
          showOn: [true],
          actionGroups: [
            {
              actions: [
                {
                  action: "switchValuesPlay",
                  value: {
                    eventType: "jumpBall",
                    property: "subType",
                    values: ["won", "lost"],
                  },
                  type: "main",
                },
                {
                  action: "nextState",
                  value: null,
                  type: "editState",
                },
                { action: "setState", value: true, type: "confirmArrows" },
              ],
              conditions: [],
            },
          ],
        },
      ],
    },
  ],
};
